/** Customer login QR poster helpers (shared print/canvas utils from driver sheet). */

import {
    buildPortalQrSheetHtml,
    downloadCanvasAsPng,
    loadPosterLogoDataUrl,
    printHtmlDocument,
    renderPortalQrPosterCanvas,
    resolvePosterLogoPath,
} from './driverQrSheetUtils';

export {
    loadPosterLogoDataUrl,
    printHtmlDocument,
    downloadCanvasAsPng,
    resolvePosterLogoPath,
};

export const CUSTOMER_QR_SHEET_COPY = {
    title: 'Customer Login',
    subtitle:
        'Scan this QR code to open the customer app, then sign in with your registered mobile number and OTP.',
    footerLine1: 'For registered customers · Keep this poster at your office or depot',
    footerLine2: (companyName) => `Powered by ${companyName}`,
    qrAlt: 'Customer login QR code',
};

export function buildCustomerQrSheetHtml(assets) {
    return buildPortalQrSheetHtml(CUSTOMER_QR_SHEET_COPY, assets);
}

export function renderCustomerQrPosterCanvas(assets) {
    return renderPortalQrPosterCanvas(CUSTOMER_QR_SHEET_COPY, assets);
}
